import { pushWithMaxSize } from '@/utils/pushWithMaxSize';

import { DataType, NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { SensorData } from '../interfaces/IEventDispatcher';
import { ISensorsManagement } from '../interfaces/ISensorsManagement';

export class SensorsManager implements ISensorsManagement {
  private data: Map<string, SensorData> = new Map();

  constructor(private plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin) {}

  getAll() {
    return Array.from(this.data.values());
  }

  get(id: string) {
    return this.data.get(id);
  }

  init(id: string, battery = 0) {
    const data: SensorData = {
      id,
      batteryLevel: battery,
      movementHistory: [],
    };

    this.data.set(id, data);
  }

  updateMovement(id: string, movement: number) {
    const updatedSensor = this.data.get(id) ?? {
      id,
      batteryLevel: 0,
      movementHistory: [],
    };

    updatedSensor.movementHistory = pushWithMaxSize(updatedSensor.movementHistory, movement, 20);
    this.data.set(id, updatedSensor);
  }

  resetMovementHistory() {
    for (const sensor of this.data.values()) {
      sensor.movementHistory = [];
      this.data.set(sensor.id, sensor);
    }
  }

  updateBattery(id: string, battery: number) {
    const updatedSensor = this.data.get(id) ?? {
      id,
      batteryLevel: 0,
      movementHistory: [],
    };

    updatedSensor.batteryLevel = battery;
    this.data.set(id, updatedSensor);
  }

  async getData(id: string, dataType: DataType): Promise<{ data: unknown }> {
    return this.plugin.getData({ macAddress: id, dataType });
  }
}
